import script from "./CalculatorDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./CalculatorDescription.vue?vue&type=script&setup=true&lang=ts"

import "./CalculatorDescription.vue?vue&type=style&index=0&id=35b20da1&scoped=scss&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b20da1"]])

export default __exports__